/**
 * 封装 sdk
 * @author fredhaochen
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Aegis from 'aegis-web-sdk';
import { DefaultCfg } from './crm-report-sdk';
import { createHttp, testDownloadSpeed, SPEED_MIN } from './util';
import { getContent } from './contentTpl';
import { init, captureException } from '@sentry/browser';
var newUserName = '';
var performance = null;
/**
 * 生成一个符合UUID版本4规范的字符串。
 * 该函数通过替换字符串模板中的`x`和`y`字符来生成UUID。
 * `x`字符被替换为0-9或a-f之间的随机数，`y`字符被替换为8、9、a或b中的一个，
 * 以确保生成的UUID符合版本4的规范。
 * @returns {string} 一个UUID字符串。
 */
var uuid = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0;
        var v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};
var autoPvId = "page-visit-request-".concat(uuid());
var getOAEnv = function (env, system) {
    if (system === 'xiaoshouyi') {
        if (env && env !== 'uat') {
            return 'prod';
        }
        else {
            return 'dev';
        }
    }
    else {
        return 'prod';
    }
};
export var createCrmReportSdk = function (factoryOptions) {
    var _a;
    var system = factoryOptions.system, id = factoryOptions.id, env = factoryOptions.env, _b = factoryOptions.pvId, pvId = _b === void 0 ? autoPvId : _b, robotKey = factoryOptions.robotKey, chartId = factoryOptions.chartId, staffname = factoryOptions.staffname, config = factoryOptions.config, useAegis = factoryOptions.useAegis, aegisConfig = factoryOptions.aegisConfig, module = factoryOptions.module, responseRtx = factoryOptions.responseRtx, dutyRtx = factoryOptions.dutyRtx;
    // Aegis 唯一实例
    var aegis = useAegis ? useAegis(performanceReport) : new Aegis(__assign({ 
        // 一、规范默认参数
        // ① 开启接口测速
        reportApiSpeed: system === 'xiaoshouyi' ? true : ((aegisConfig === null || aegisConfig === void 0 ? void 0 : aegisConfig.reportApiSpeed) || false), 
        // ② 开启静态资源测速
        reportAssetSpeed: (aegisConfig === null || aegisConfig === void 0 ? void 0 : aegisConfig.reportAssetSpeed) || false, 
        // ③ 开启页面测速
        pagePerformance: (aegisConfig === null || aegisConfig === void 0 ? void 0 : aegisConfig.pagePerformance) || true, 
        // 上报节流时间，在该时间段内的上报将会合并到一个上报请求中。
        delay: 2000, 
        // 当前页面是否是单页应用？true的话将会监听hashchange及history api，在页面跳转时进行pv上报
        spa: true, 
        // 测速日志是否抽样
        speedSample: false, 
        // 没有上报的部分，重新上报一次
        sendBeacon: true, beforeRequest: function (data) {
            // 使用sentry上报错误 不用aegis 跨域捕获业务侵入性大
            if ((data === null || data === void 0 ? void 0 : data.logType) === 'log') {
            }
            // 网络连接性能总结为最接近的蜂窝网络连接类型（比如 2G）so effectiveType 可取值有 'slow-2g'、'2g'、'3g' 或者 '4g'
            if ((data === null || data === void 0 ? void 0 : data.logType) === 'performance' && !(config === null || config === void 0 ? void 0 : config.isClosePerformanceReport)) {
                performance = data.logs;
                performanceReport(data.logs);
            }
            // chrome 有lcp则使用
            if ((data === null || data === void 0 ? void 0 : data.logType) === 'vitals' && !(config === null || config === void 0 ? void 0 : config.isClosePerformanceReport)) {
                performanceReport(performance);
            }
            return data;
        }, api: {
            ret: ['code'],
            errCode: ['unknown'],
            // reportRequest: boolean, 默认为false。 开启aegis.info全量上报, 不需要白名单配置。并上报所有接口请求信息（请开启reportApiSpeed）
            reportRequest: true,
            // 记录 request header
            reqHeaders: ['X-Seq-Id', 'X-Pv-Id'],
            // 返回码上报钩子函数
            retCodeHandler: function (data, url, xhr) {
                var _a;
                // data 是string类型，如果需要对象需要手动parse下
                // url 为请求url
                // xhr 响应,可以通过xhr.response拿到完整的后台响应
                try {
                    data = JSON.parse(data);
                }
                catch (e) { }
                // code 取值 data?.code 为 undefined 或 为 null 的情况下 取值 data?.ret_code
                var retCode = (_a = data === null || data === void 0 ? void 0 : data.code) !== null && _a !== void 0 ? _a : data === null || data === void 0 ? void 0 : data.ret_code;
                return {
                    isErr: !((+(xhr === null || xhr === void 0 ? void 0 : xhr.status) === 200 && +retCode >= 0) || +(xhr === null || xhr === void 0 ? void 0 : xhr.status) === 401),
                    code: retCode,
                };
            },
            // 规范，apiDetail 一定要配合 retParamHandler 和 retBodyHandler 一起使用，retParamHandler 处理不保留入参，retBodyHandler 处理返回包仅保留 code 和 message 信息
            // 1. 开启上报 入参和回包
            apiDetail: true,
        }, 
        // 二、基础配置
        // Aegis 上报key
        id: id || ((_a = DefaultCfg[system]) === null || _a === void 0 ? void 0 : _a.AEGIS_KEY), 
        // Aegis 环境变量
        env: env, 
        // 当前用户名称
        uin: staffname, 
        // 额外参数1，记录 pvId
        ext1: pvId, 
        // 额外参数2，记录页面归属业务线，框架路由、页面路由
        ext2: JSON.stringify({
            operatingBusiness: system,
            frameworkRoute: '',
            route: '', // 页面路由
        }) }, aegisConfig));
    // 暴露 setConfig
    function aegisSetConfig(config) {
        try {
            if (typeof (aegis === null || aegis === void 0 ? void 0 : aegis.setConfig) === 'function') {
                aegis.setConfig(config);
            }
        }
        catch (e) { }
    }
    // 重置 用户名
    function aegisResetStaffname(staffname) {
        try {
            if (typeof (aegis === null || aegis === void 0 ? void 0 : aegis.setConfig) === 'function') {
                return aegis.setConfig({
                    uin: staffname,
                });
            }
        }
        catch (e) { }
    }
    // 内网woa域名请求实例
    function getWoaRequestInstant($content, chatid, atShortName) {
        var _a;
        if (chatid === void 0) { chatid = ''; }
        if (atShortName === void 0) { atShortName = true; }
        var apiPath = 'crm-report-error/crm_error_robot_webhook';
        var url = "api?".concat(apiPath);
        var formatEnv = getOAEnv(env, system);
        var _content = {
            msgtype: 'markdown',
            content: $content,
            markdown: { content: $content, at_short_name: atShortName },
        };
        var param = {
            apiPath: apiPath,
            data: __assign({ chatid: chatid }, _content),
            envId: formatEnv === 'prod' ? 4 : 2,
            options: {
                query: { key: robotKey || ((_a = DefaultCfg[system]) === null || _a === void 0 ? void 0 : _a.BOT_KEY) },
            },
        };
        var baseUri = formatEnv === 'prod' ? 'https://panshi.woa.com/omp-service' : 'https://pre.panshi.woa.com/omp-service';
        var instance = createHttp({ baseUri: baseUri, url: url });
        return {
            instance: instance,
            url: url,
            param: param,
        };
    }
    // 外网域名请求实例
    function getTencentRequestInstant($content, chatid, atShortName) {
        var _a;
        if (chatid === void 0) { chatid = ''; }
        if (atShortName === void 0) { atShortName = true; }
        var url = '/robot-report';
        var _content = {
            msgtype: 'markdown',
            content: $content,
            markdown: { content: $content, at_short_name: atShortName },
        };
        var param = {
            data: __assign({ chatid: chatid }, _content),
            options: {
                query: { key: robotKey || ((_a = DefaultCfg[system]) === null || _a === void 0 ? void 0 : _a.BOT_KEY) },
            },
        };
        var instance = createHttp({ baseUri: 'https://partner.cloud.tencent.com', url: '/robot-report' });
        return {
            instance: instance,
            url: url,
            param: param,
        };
    }
    // 调用接口，给机器人发送消息
    function sendMarkDownMsgToBot($content, chatid, atShortName) {
        if (chatid === void 0) { chatid = ''; }
        if (atShortName === void 0) { atShortName = true; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, instance, url, param;
            return __generator(this, function (_b) {
                _a = (window.location.host.indexOf('woa') > -1)
                    ? getWoaRequestInstant($content, chatid, atShortName)
                    : getTencentRequestInstant($content, chatid, atShortName), instance = _a.instance, url = _a.url, param = _a.param;
                instance.post(url, param).then(function (res) {
                    console.log(res);
                }).catch(function (err) {
                    console.log(err);
                });
                return [2 /*return*/];
            });
        });
    }
    // 使用 sentry
    function initSentry() {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var dsn;
            return __generator(this, function (_b) {
                dsn = (_a = DefaultCfg[system]) === null || _a === void 0 ? void 0 : _a.SENTRY_DSN;
                if (dsn && !(config === null || config === void 0 ? void 0 : config.isCloseErrorReport)) {
                    return [2 /*return*/, init({
                            dsn: dsn,
                            release: '',
                            debug: config === null || config === void 0 ? void 0 : config.debug,
                            // sentry 上报前回调
                            beforeSend: function (event) {
                                var _a, _b, _c, _d, _e, _f, _g, _h;
                                try {
                                    var exception = (_b = (_a = event === null || event === void 0 ? void 0 : event.exception) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b[0];
                                    var message_1 = "".concat(exception === null || exception === void 0 ? void 0 : exception.value);
                                    var type = "".concat(exception === null || exception === void 0 ? void 0 : exception.type);
                                    var stack_1 = (_e = (_d = (_c = exception === null || exception === void 0 ? void 0 : exception.stacktrace) === null || _c === void 0 ? void 0 : _c.frames) === null || _d === void 0 ? void 0 : _d.map(function (item) { return "".concat(item.filename, "(").concat(item.lineno, ":").concat(item.colno, ")"); })) !== null && _e !== void 0 ? _e : [];
                                    // 如果有告警白名单js文件则过滤不在的js文件
                                    var whiteListJsPatterns = config === null || config === void 0 ? void 0 : config.whiteListJsPatterns;
                                    if (Array.isArray(whiteListJsPatterns) && whiteListJsPatterns.length > 0) {
                                        var isInJSWhiteList = whiteListJsPatterns.some(function (pattern) { return new RegExp(pattern).test(stack_1[0]); });
                                        if (!isInJSWhiteList) {
                                            console.warn('Ignore exception', exception);
                                            return null;
                                        }
                                    }
                                    // 手动过滤一些无效错误
                                    var whiteListErrorPatterns = config === null || config === void 0 ? void 0 : config.whiteListErrorPatterns;
                                    if (Array.isArray(whiteListErrorPatterns) && whiteListErrorPatterns.length > 0) {
                                        var isErrorIgnore = whiteListErrorPatterns.some(function (pattern) { return new RegExp(pattern).test(message_1); });
                                        if (isErrorIgnore) {
                                            console.warn('Ignore exception', exception);
                                            return null;
                                        }
                                    }
                                    // 过滤掉一些无效错误
                                    if (typeof message_1 === 'string' && (message_1.startsWith('ResizeObserver')
                                        || message_1.startsWith('Non-Error promise')
                                        || message_1.startsWith('SecurityError')
                                        || message_1.startsWith('Cross-origin')
                                        || message_1.startsWith('NotFoundError')
                                        || message_1.startsWith('Load failed')
                                        || /(Access-Control-Allow-Origin)/.test(message_1)
                                        || message_1.includes('发生了SSL错误，无法建立与该服务器的安全连接。')
                                        || message_1.includes('Can\'t find variable: watermark')
                                        || message_1.includes('Can\'t find variable: WeixinJSBridge')
                                        || message_1.includes('Failed to execute \'observe\' on \'MutationObserver\''))) {
                                        console.warn('Ignore exception', exception);
                                        return null;
                                    }
                                    // 屏蔽掉浏览器扩展的告警
                                    if (Array.isArray(stack_1) && stack_1[0] && /(safari|chrome)-extension:/.test(stack_1[0])) {
                                        console.warn('Ignore exception', exception);
                                        return null;
                                    }
                                    var $content = getContent({
                                        system: system,
                                        errorLogInfo: { name: '前端错误', msg: message_1, type: type, stack: stack_1 },
                                        staffname: newUserName || staffname,
                                        env: env,
                                        module: module,
                                        pvId: pvId,
                                        dutyRtx: dutyRtx || ((_f = DefaultCfg[system]) === null || _f === void 0 ? void 0 : _f.DUTY_RTX),
                                        responseRtx: responseRtx || ((_g = DefaultCfg[system]) === null || _g === void 0 ? void 0 : _g.RESPONSE_RTX),
                                    });
                                    sendMarkDownMsgToBot($content, chartId || ((_h = DefaultCfg[system]) === null || _h === void 0 ? void 0 : _h.ALARM_CHAT_ID), true);
                                    return event;
                                }
                                catch (error) {
                                }
                            },
                        })];
                }
                return [2 /*return*/];
            });
        });
    }
    // 性能监控
    function performanceReport(data) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return __awaiter(this, void 0, void 0, function () {
            var blackListPerformancePatterns, isInBlackListPerformancePatterns, downloadSeed, res, lcp, _lcp, downlink, netWorkType, $content, $content, error_1;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        _j.trys.push([0, 2, , 3]);
                        blackListPerformancePatterns = config === null || config === void 0 ? void 0 : config.blackListPerformancePatterns;
                        if (Array.isArray(blackListPerformancePatterns) && blackListPerformancePatterns.length > 0) {
                            isInBlackListPerformancePatterns = blackListPerformancePatterns.some(function (pattern) { return new RegExp(pattern).test(window.location.href); });
                            if (isInBlackListPerformancePatterns) {
                                return [2 /*return*/, null];
                            }
                        }
                        downloadSeed = 0;
                        return [4 /*yield*/, testDownloadSpeed()];
                    case 1:
                        res = _j.sent();
                        if (+(res === null || res === void 0 ? void 0 : res.speed) < SPEED_MIN) {
                            return [2 /*return*/, null];
                        }
                        else {
                            downloadSeed = +(res === null || res === void 0 ? void 0 : res.speed);
                        }
                        lcp = ((_a = DefaultCfg[system]) === null || _a === void 0 ? void 0 : _a.MAX_LCP) || (config === null || config === void 0 ? void 0 : config.maxLcp);
                        _lcp = (data === null || data === void 0 ? void 0 : data.LCP) || (data === null || data === void 0 ? void 0 : data.firstScreenTiming);
                        downlink = (_b = navigator['connection']) === null || _b === void 0 ? void 0 : _b.downlink;
                        netWorkType = navigator['connection'].effectiveType;
                        // 网络不好的直接过滤 不告警
                        if (netWorkType !== '4g') {
                            return [2 /*return*/, null];
                        }
                        if (_lcp > lcp) {
                            // 有Core Web Vitals优先用 更准确
                            if (data === null || data === void 0 ? void 0 : data.LCP) {
                                $content = getContent({
                                    system: system,
                                    pvId: pvId,
                                    errorLogInfo: {
                                        name: '前端性能 Core Web Vitals',
                                        msg: "LCP\uFF1A".concat(_lcp, " ms(\u52A0\u8F7D\u6027\u80FD);\n             FCP\uFF1A").concat(data.FCP, " ms(\u53EF\u4EA4\u4E92\u6027);\n             CLS\uFF1A").concat(data.CLS, " ms(\u89C6\u89C9\u7A33\u5B9A\u6027);\n             \u5F53\u524D\u4E0B\u8F7D\u901F\u5EA6\uFF1A").concat(downloadSeed, "kb/s;\n             \u53C2\u8003\u5E26\u5BBD\uFF1A").concat(downlink, " Mb/s; "),
                                        type: "LCP\u65F6\u957F\u544A\u8B66(".concat((data === null || data === void 0 ? void 0 : data.LCP) > 4000 ? '超时' : '待改进', ")"),
                                    },
                                    staffname: newUserName || staffname,
                                    env: env,
                                    module: module,
                                    dutyRtx: dutyRtx || ((_c = DefaultCfg[system]) === null || _c === void 0 ? void 0 : _c.DUTY_RTX),
                                    responseRtx: responseRtx || ((_d = DefaultCfg[system]) === null || _d === void 0 ? void 0 : _d.RESPONSE_RTX),
                                });
                                sendMarkDownMsgToBot($content, chartId || ((_e = DefaultCfg[system]) === null || _e === void 0 ? void 0 : _e.ALARM_CHAT_ID), true);
                            }
                            else {
                                if (data === null || data === void 0 ? void 0 : data.firstScreenTiming) {
                                    $content = getContent({
                                        system: system,
                                        pvId: pvId,
                                        errorLogInfo: {
                                            name: '前端性能首屏渲染',
                                            msg: "\u9996\u5C4F\u6E32\u67D3\u65F6\u95F4\uFF1A".concat(_lcp, "ms;\n                 \u5F53\u524D\u4E0B\u8F7D\u901F\u5EA6\uFF1A").concat(downloadSeed, "kb/s;\n                 DNS\u67E5\u8BE2\uFF1A").concat(data === null || data === void 0 ? void 0 : data.dnsLookup, "ms; \n                 TCP\u8FDE\u63A5\uFF1A").concat(data === null || data === void 0 ? void 0 : data.tcp, "ms; \n                 SSL\u5EFA\u8FDE\uFF1A").concat(data === null || data === void 0 ? void 0 : data.ssl, "ms; \n                 \u8BF7\u6C42\u54CD\u5E94\uFF1A").concat(data === null || data === void 0 ? void 0 : data.ttfb, "ms; \n                 \u5185\u5BB9\u4F20\u8F93\uFF1A").concat(data === null || data === void 0 ? void 0 : data.contentDownload, "ms;\n                 DOM\u89E3\u6790\uFF1A").concat(data === null || data === void 0 ? void 0 : data.domParse, "ms; \n                 \u8D44\u6E90\u52A0\u8F7D\uFF1A").concat(data === null || data === void 0 ? void 0 : data.resourceDownload, "ms;\n                 \u53C2\u8003\u5E26\u5BBD\uFF1A").concat(downlink, " Mb/s; "),
                                            type: '首屏渲染时间告警',
                                        },
                                        staffname: newUserName || staffname,
                                        env: env,
                                        module: module,
                                        dutyRtx: dutyRtx || ((_f = DefaultCfg[system]) === null || _f === void 0 ? void 0 : _f.DUTY_RTX),
                                        responseRtx: responseRtx || ((_g = DefaultCfg[system]) === null || _g === void 0 ? void 0 : _g.RESPONSE_RTX),
                                    });
                                    sendMarkDownMsgToBot($content, chartId || ((_h = DefaultCfg[system]) === null || _h === void 0 ? void 0 : _h.ALARM_CHAT_ID), true);
                                }
                            }
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _j.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    // 将告警和aegis的userName都重置
    function setUserName(userName) {
        if (userName) {
            newUserName = userName;
            aegisResetStaffname(userName);
        }
    }
    return {
        // 初始化告警
        initSentry: initSentry,
        // 手动捕捉错误
        captureException: captureException,
        // 设置用户名称
        setUserName: setUserName,
        // 覆盖aegis的配置
        aegisSetConfig: aegisSetConfig,
    };
};
